var exports = {
  "Y": "AltTextTooltip.module__tooltip___dXgxSz",
  "Q": "AltTextTooltip.module__text___dXgxSz",
};

module.exports = exports;
